/**
 * Logo-sentinel replacement — moved VERBATIM from ui/skin-wizard/apply-state.js
 * (crm-bridge B2) so the Worker's project-import path can materialize the logo
 * the same way the wizard does. apply-state.js re-imports from here: ONE
 * definition, worker-safe (pure recursion + one shared constant).
 */
import { LOGO_SENTINEL_VALUE } from './source-domain-url.js';

export function replaceLogoSentinel(value, replacement) {
  if (typeof value === 'string') {
    if (!replacement || !value.includes(LOGO_SENTINEL_VALUE)) return value;
    return value
      .split(LOGO_SENTINEL_VALUE)
      .join(replacement)
      .replace(/\sdata-pb-needs-upload=(["'])logo\1/g, '');
  }
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) value[i] = replaceLogoSentinel(value[i], replacement);
    return value;
  }
  if (value && typeof value === 'object') {
    for (const [key, child] of Object.entries(value)) {
      value[key] = replaceLogoSentinel(child, replacement);
    }
  }
  return value;
}
